module.exports = __webpack_public_path__ + "assets/img/safari.4826da21.svg";